import React from "react";
import PropTypes from "prop-types";
import { TableCell, TableRow, Checkbox } from "@mui/material";
import { TextField, Autocomplete } from "@totalsoft/rocket-ui";
import { onCheckBoxChange } from "utils/propertyChangeAdapters";
import { withParams } from "providers/ParamsConsumer";
import { isValid, getErrors } from "@totalsoft/pure-validations-react";
import PhoneNumberField from "components/common/PhoneNumberTextField";

export const DealerContactModeRowComponent = ({
  idx,
  contactModes,
  dealerContactMode,
  onPropertyChange,
  params,
  validation
}) => {
  return (
    <React.Fragment>
      <TableRow>
        <TableCell colSpan={4} style={{ paddingRight: "70px" }}>
          <Autocomplete
            id={"contactMode_contactMode_" + idx}
            fullWidth
            value={contactModes.length > 0 ? dealerContactMode.contactModeId || "" : ""}
            labelKey="contactModeName"
            valueKey="contactModeId"
            simpleValue={true}
            onChange={onPropertyChange("contactModeId")}
            options={contactModes}
          />
        </TableCell>

        <TableCell colSpan={4} style={{ paddingRight: "0px" }}>
          {dealerContactMode.contactModeId === params.contactModeEmail && (
            <TextField
              id={"contactMode_contactInfo_" + idx}
              name={"contactInfo"}
              fullWidth
              value={dealerContactMode.contactInfo || ""}
              error={!isValid(validation.contactInfo)}
              helperText={getErrors(validation.contactInfo)}
              onChange={onPropertyChange("contactInfo")}
            />
          )}
          {(dealerContactMode.contactModeId === params.contactModeMobilePhone ||
            dealerContactMode.contactModeId === params.contactModePhone) && (
            <PhoneNumberField
              id={"contactMode_contactInfo_" + idx}
              defaultCountry={params.defaultCountryCode}
              country={dealerContactMode.phoneCountryCode}
              name={"contactInfo"}
              fullWidth
              value={dealerContactMode.contactInfo || ""}
              error={!isValid(validation.contactInfo)}
              helperText={getErrors(validation.contactInfo)}
              onChange={onPropertyChange("contactInfo")}
            />
          )}
        </TableCell>

        <TableCell colSpan={2} style={{ paddingRight: "0px", textAlign: "center" }}>
          <Checkbox
            id={"contactMode_isDefault_" + idx}
            checked={Boolean(dealerContactMode.isDefault)}
            onChange={onCheckBoxChange(onPropertyChange("isDefault"))}
            color="primary"
            name="isDefault"
          />
        </TableCell>
        <TableCell colSpan={2} style={{ paddingRight: "0px", textAlign: "center" }}>
          <Checkbox
            id={"contactMode_isActive_" + idx}
            checked={Boolean(dealerContactMode.isActive)}
            onChange={onCheckBoxChange(onPropertyChange("isActive"))}
            color="primary"
            name="isActive"
          />
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

DealerContactModeRowComponent.propTypes = {
  idx: PropTypes.number,
  params: PropTypes.object,
  deleteContactMode: PropTypes.func,
  onPropertyChange: PropTypes.func.isRequired,
  contactMode: PropTypes.object.isRequired,
  dealerContactMode: PropTypes.object.isRequired,
  contactModes: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired
};

export default withParams(DealerContactModeRowComponent);
